import { Dialog, DialogContent } from "@mui/material";
import MainComponente from "./MainComponente";
import Loading from "../../Loading";

const ModalAnalisar = ({ open, setOpen, isTab, tipoPrevia, contextHook }) => {
  const { limparDadosVersao } = contextHook();

  if (!open) return null;

  const handleClose = async () => {
    limparDadosVersao(); // Limpar dados do context
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      fullScreen
      TransitionProps={{ unmountOnExit: false }} // Mantém o modal montado
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          height: "100%", // Garante que o conteúdo ocupe todo o espaço
        }}
      >
        <MainComponente
          closeModal={handleClose}
          tabComponent={isTab}
          tipoPrevia={tipoPrevia}
          contextHook={contextHook}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ModalAnalisar;
